import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { StoryStatus, Client } from '@/types/database'

type SortOrder = 'newest' | 'oldest' | 'category'
type ActiveTab = StoryStatus

interface UIState {
  activeTab: ActiveTab
  sortOrder: SortOrder
  sidebarOpen: boolean
  viewingAs: Client | null
  setActiveTab: (tab: ActiveTab) => void
  setSortOrder: (order: SortOrder) => void
  setSidebarOpen: (open: boolean) => void
  setViewingAs: (client: Client | null) => void
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      activeTab: 'ready',
      sortOrder: 'newest',
      sidebarOpen: true,
      viewingAs: null,
      setActiveTab: (activeTab) => set({ activeTab }),
      setSortOrder: (sortOrder) => set({ sortOrder }),
      setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),
      setViewingAs: (viewingAs) => set({ viewingAs }),
    }),
    {
      name: 'gogrov_ui',
      partialize: (state) => ({
        activeTab: state.activeTab,
        sortOrder: state.sortOrder,
        // theme is gone: GoGrov is dark only (Brian, Oct 14).
        // viewingAs intentionally excluded — resets on page reload
      }),
    }
  )
)
